export class WebhookV1StandardPayloadBackupJobFailedArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "backupJobFailed",
            "baseName": "backupJobFailed",
            "type": "WebhookV1BackupJobFailedArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadBackupJobFailedArguments.attributeTypeMap;
    }
    constructor() {
    }
}
